import { useState } from 'react';

// import { routeTypes } from '../../useSystemRoutes'
import { useUsers, userTypes } from '../../../api/useUsers'
import { useSystemPrompt } from '../../../useSystemPrompt';

import { documentTypes } from "../../../api/useDocuments"
import { validateRouteType } from './default';

import {
    useDependencies,
    targetTypes as dependencyTargetTypes,
    dependencyModules,
    dependencyRelations,
    dependencyRefs,
    formikDependencyStateField,
} from "../../../api/useDependencies"

export function useStateSalesDebitNote() {

    const { promptMessage } = useSystemPrompt()
    const { get } = useUsers({ userType: userTypes.customer })

    const { getDependencyItem } = useDependencies()

    // const validateRouteType = (val) => {
    //     if (
    //         val !== routeTypes.admin &&
    //         val !== routeTypes.retail
    //     ) throw new Error(`Unsupported route : ${val}`)
    // }

    // const fetchBranches = async ({ userType, userId }) => {

    //     try {

    //         // if(userType === userTypes.customer){
    //         const { data } = await get({ id: userId, userType: userTypes.customer, dataTypesArray: ["branch", "shipping_address"] })

    //         // setDataBranches(data?.customer?.branches? data.customer.branches : [])
    //         // setDataShipping(data?.customer?.shipping_addresses? data.customer.shipping_addresses : [])
    //         // }

    //         // if(userType === userTypes.retail){
    //         //     const { data } = await getRetailer({ id: userId, userType: userTypes.retail, dataTypesArray: ["retail_outlet","shipping_address"] })

    //         //     setDataBranches(data?.retailer?.retail_outlets? data.retailer.retail_outlets : [])
    //         //     setDataShipping(data?.retailer?.shipping_addresses? data.retailer.shipping_addresses : [])
    //         // }

    //         return {
    //             billing: data?.customer?.branches ? data.customer.branches : [],
    //             shipping: data?.customer?.shipping_addresses ? data.customer.shipping_addresses : []
    //         }

    //     } catch (error) {
    //         promptMessage(false, `${error.message}`)
    //     }

    //     return {}

    // }

    const updateFormikState = async ({
        data,
        routeType,
        setFieldValue,
        // setDataBranches,
        // setDataShipping
    }) => {

        // validateRouteType(routeType);
        validateRouteType(routeType, documentTypes.salesDebitNote)

        const {
            document,
            items
        } = data

        // only load these fields
        setFieldValue(`remark`, document?.doc_remark ? document.doc_remark : "")

        items.forEach((e, index) => {
            setFieldValue(`rows.${index}.itemId`, e?.item_id)
            setFieldValue(`rows.${index}.name`, e?.item_name)
            setFieldValue(`rows.${index}.code`, e?.code)
            setFieldValue(`rows.${index}.description`, e?.description)
            setFieldValue(`rows.${index}.qty`, e?.qty)
            setFieldValue(`rows.${index}.uomId`, e?.uom_id)
            setFieldValue(`rows.${index}.uomName`, e?.uom_name)
            setFieldValue(`rows.${index}.price`, e?.uom_price)
        })

        // only if the set state pass in
        if (document?.user_type === "customer") {
            // if(setDataBranches && setDataShipping) {

            // get the branches
            // const branches = await fetchBranches({ userId: document?.user_id })
            // console.log('branches', branches)

            setFieldValue(`userId`, document?.user_id)
            setFieldValue(`username`, document?.profile_name)

            // setDataBranches(branches.billing)
            // setFieldValue(`billingBranchId`, document?.billing_branch_id)

            // setDataShipping(branches.shipping)
            // setFieldValue(`shippingBranchId`, document?.delivery_branch_id)
            // }
        }

        let depStates = getDependencyItem({
            targetType: dependencyTargetTypes.document,
            dependencyModule: document?.type.toLowerCase(),
            dependencyRef: dependencyRefs.document,
            targetId: document?.id,
            relation: dependencyRelations.reference,
        })

        setFieldValue(formikDependencyStateField, [depStates])

    }

    const getFormikDependencyStates = ({ values }) => {
        return {
            [`${formikDependencyStateField}`]: values[`${formikDependencyStateField}`]
        }
    }

    return {
        updateFormikState,
        getFormikDependencyStates
    }

}